module.exports = __webpack_public_path__ + "static/media/pdfImage.e3722f38.png";